import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Input } from "antd";
import "./styles.css";
import { overrideAllowClearProp, overrideCountProp, overrideShowCountProp } from "./utils.js";
import { InputPassword } from "./Password.js";
import { TextArea } from "./TextArea.js";
import { InputSearch } from "./Search.js";
import { rootClass } from "./constant.js";
import classnames from "classnames";
const InputComponent = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { allowClear: inputAllowClear, size, showCount: inputShowCount, count: inputCountConfig, ...restProps } = props;
    const allowClear = overrideAllowClearProp(inputAllowClear);
    const count = overrideCountProp(inputCountConfig);
    const showCount = overrideShowCountProp(inputShowCount);
    return /*#__PURE__*/ jsx(Input, {
        ...restProps,
        size: size,
        allowClear: allowClear,
        showCount: showCount,
        count: count,
        ref: ref,
        className: classnames(rootClass, restProps.className)
    });
});
InputComponent.displayName = 'Input';
const input_Input = Object.assign(InputComponent, {
    Password: InputPassword,
    TextArea: TextArea,
    Search: InputSearch
});
export { input_Input as Input };
